import { Store } from 'src/store/index';

const getUsedClipArtsHash = (store: Store) => store.addon.usedClipArts.clipArtsHash;
export default getUsedClipArtsHash;
